module.exports = __webpack_public_path__ + "img/ico_earthtemperature35-.d4f265a7.svg";